import { create } from "zustand";

type NavigationState = {
    activePage: string;
    setActivePage: (page: string) => void;
};

export const useNavigationStore = create<NavigationState>((set) => ({
    activePage: "/public-games",
    setActivePage: (page) => set({ activePage: page }),
}));
